{
  "FormEngineMarkdownElement": {
    "title": "Richtext"
  },
  "mask": {
    "FormEngineMarkdownElement": {
      "markdownBody": "Abschlag"
    }
  }
}